// extracted by mini-css-extract-plugin
export default {"topScoringHomes":"NFNyldMpLu4kUWI0mzoE","title":"VVkmBFKEwP2pJCeJ5a3y"};